import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FeaturedHabitKeyHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Habit Massage Center</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FeaturedHabitKeyHeader;
